export class IndefiniteArticleAdderController {
  private vowels: string = 'aeiou';
  private lettersPronouncedLikeVowels: string = 'aefhilmnorsxz';

  constructor() {}

  public word: string;
  public isAbbreviation: boolean;

  public getArticle(word: string): string {
    if (_.isUndefined(word) || _.isEmpty(word)) {
      return '';
    }

    const letterSet = this.isAbbreviation ? this.lettersPronouncedLikeVowels : this.vowels;

    const firstLetterIsVowel = _.includes(letterSet, _.first(word).toLowerCase());
    return firstLetterIsVowel ? 'an' : 'a';
  }
}

angular
  .module('capability-ng-global')
  .controller('ngIndefiniteArticleAdderController', IndefiniteArticleAdderController)
  .component('indefiniteArticleAdder', {
    transclude: true,
    controller: 'ngIndefiniteArticleAdderController',
    templateUrl: 'lib/global/components/indefinite_article_adder/indefinite_article_adder.html',
    controllerAs: '$ctrl',
    bindings: {
      word: '<',
      isAbbreviation: '<?'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/global/components/indefinite_article_adder/indefinite_article_adder.ts